import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Plus, X, Upload} from "lucide-react";
import apiRequests from "../../../Component/axios/config/config";
import toast from "react-hot-toast";
import Dropdown from "../../../Component/Dropdown/Drowdown";

export default function ProductCreate() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: {
            en: "",
            fa: "",
            fr: "",
            de: "",
            zh: "",
        },
        price: "",
        stock: "",
        category: "",
        images: [],
        description: {
            en: "",
            fa: "",
            fr: "",
            de: "",
            zh: "",
        },
    });

    const [loadingImage, setLoadingImage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [imageUrl, setImageUrl] = useState([]);
    const [showModalCategory, setShowModalCategory] = useState(false);
    const [CategoryListData, setCategoryListData] = useState([]);
    const [Category, setCategory] = useState({
        id: "",
        name: ""
    });

    useEffect(() => {
        apiRequests.get("/api/category/get-all-admin", {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                'Content-Type': 'application/json',
            }
        })
            .then((res) => setCategoryListData(res.data.data))
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
    }, []);

    useEffect(() => {
        setFormData({...formData, category: Category.id});
    }, [Category]);

    function readImage() {
        document.querySelector('#profile')?.click();
    }

    function UploadImage(e) {
        const formDataUpload = new FormData();
        formDataUpload.append('file', e.target.files[0]);

        setLoadingImage(true);
        apiRequests.post(`/api/file/v1/upload-admin`, formDataUpload, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            toast.success("Upload Image successfully");
            setImageUrl([...imageUrl, URL.createObjectURL(e.target.files[0])]);
            setFormData(prev => ({
                ...prev,
                images: [...prev.images, response.data.message._id]
            }));
        }).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                navigate("/login");
            }
        }).finally(() => {
            setLoadingImage(false);
        });
    }

    function createProduct() {
        setIsLoading(true);
        apiRequests.post("/api/product/create-admin", formData)
            .then((response) => {
                toast.success(response.data.en_message);
                setFormData({
                    name: {
                        en: "",
                        fa: "",
                        fr: "",
                        de: "",
                        zh: "",
                    },
                    price: "",
                    stock: "",
                    category: "",
                    images: [],
                    description: {
                        en: "",
                        fa: "",
                        fr: "",
                        de: "",
                        zh: "",
                    },
                });
                setImageUrl([]);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setIsLoading(false));
    }

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-4xl mx-auto">

                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-2xl font-bold">Create New Product</h1>
                    <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-700">
                        <X size={24}/>
                    </button>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="border rounded-xl p-4 flex flex-col gap-3 md:col-span-2">
                            <label className="block mb-2 text-firstColor-shade9 text-2xl font-bold">Product Name *</label>
                            <div className="flex flex-col gap-1">
                                <label className="block mb-2 font-medium">English</label>
                                <input
                                    type="text"
                                    required
                                    placeholder="enter english name"
                                    className="w-full p-2 border rounded-lg"
                                    value={formData.name.en}
                                    onChange={e => setFormData({
                                        ...formData,
                                        name: {...formData.name, en: e.target.value}
                                    })}
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="block mb-2 font-medium">Persian</label>
                                <input
                                    type="text"
                                    required
                                    placeholder="نام فارسی را وارد کنید"
                                    className="w-full p-2 border rounded-lg"
                                    value={formData.name.fa}
                                    onChange={e => setFormData({
                                        ...formData,
                                        name: {...formData.name, fa: e.target.value}
                                    })}
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="block mb-2 font-medium">French</label>
                                <input
                                    type="text"
                                    required
                                    placeholder="Saisissez le nom français"
                                    className="w-full p-2 border rounded-lg"
                                    value={formData.name.fr}
                                    onChange={e => setFormData({
                                        ...formData,
                                        name: {...formData.name, fr: e.target.value}
                                    })}
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="block mb-2 font-medium">German</label>
                                <input
                                    type="text"
                                    required
                                    placeholder="Geben Sie den deutschen Namen ein"
                                    className="w-full p-2 border rounded-lg"
                                    value={formData.name.de}
                                    onChange={e => setFormData({
                                        ...formData,
                                        name: {...formData.name, de: e.target.value}
                                    })}
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="block mb-2 font-medium">Chinese</label>
                                <input
                                    type="text"
                                    required
                                    placeholder="输入中文姓名"
                                    className="w-full p-2 border rounded-lg"
                                    value={formData.name.zh}
                                    onChange={e => setFormData({
                                        ...formData,
                                        name: {...formData.name, zh: e.target.value}
                                    })}
                                />
                            </div>


                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Price *</label>
                            <input
                                type="number"
                                required
                                step="0.01"
                                placeholder="enter price"
                                className="w-full p-2 border rounded-lg"
                                value={formData.price}
                                onChange={e => setFormData({...formData, price: parseFloat(e.target.value) || ""})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Stock *</label>
                            <input
                                type="number"
                                required
                                placeholder="enter stock"
                                className="w-full p-2 border rounded-lg"
                                value={formData.stock}
                                onChange={e => setFormData({...formData, stock: parseInt(e.target.value)})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Category *</label>
                            <div className="inline-block relative w-full" onClick={() => setShowModalCategory(!showModalCategory)}>
                                <input
                                    className="w-full p-2 border rounded-lg"
                                    value={Category.name}
                                    readOnly
                                    placeholder="enter category"
                                />
                                {showModalCategory && <Dropdown data={CategoryListData} setOpen={setShowModalCategory} setValue={setCategory}/>}
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 p-4 rounded-xl border border-gray-200">
                        <h3 className="text-firstColor-shade9 text-2xl font-bold mb-4">Descriptions</h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block mb-2 font-medium">Description (English)</label>
                                <textarea
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    value={formData.description.en}
                                    onChange={e => setFormData({
                                        ...formData,
                                        description: {...formData.description, en: e.target.value}
                                    })}
                                    placeholder="Enter English description"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (Persian)</label>
                                <textarea
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    value={formData.description.fa}
                                    onChange={e => setFormData({
                                        ...formData,
                                        description: {...formData.description, fa: e.target.value}
                                    })}
                                    placeholder="توضیحات فارسی را وارد کنید"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (French)</label>
                                <textarea
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    value={formData.description.fr}
                                    onChange={e => setFormData({
                                        ...formData,
                                        description: {...formData.description, fr: e.target.value}
                                    })}
                                    placeholder="Entrez la description en français"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (German)</label>
                                <textarea
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    value={formData.description.de}
                                    onChange={e => setFormData({
                                        ...formData,
                                        description: {...formData.description, de: e.target.value}
                                    })}
                                    placeholder="Geben Sie die Beschreibung auf Deutsch ein"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (Chinese)</label>
                                <textarea
                                    className="w-full p-2 border rounded-lg resize-none"
                                    rows={3}
                                    value={formData.description.zh}
                                    onChange={e => setFormData({
                                        ...formData,
                                        description: {...formData.description, zh: e.target.value}
                                    })}
                                    placeholder="输入中文描述"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-6">
                        <label className="block mb-2 font-medium">Product Images *</label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                            {imageUrl.map((img, index) => (
                                <div key={index} className="relative group">
                                    <img
                                        src={img}
                                        alt="Preview"
                                        className="h-32 w-full object-cover rounded-lg border"
                                    />
                                </div>
                            ))}
                            <label className="h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                {!loadingImage &&
                                    <input
                                        type="file" accept="image/*"
                                        onClick={() => readImage()}
                                        onChange={UploadImage}
                                        className="hidden"
                                    />
                                }

                                <div className="text-center text-gray-500">
                                    {loadingImage ? (
                                        <div className="mx-auto mb-2">
                                            <svg aria-hidden="true"
                                                 className="inline w-5 h-5 text-white animate-spin fill-white"
                                                 viewBox="0 0 100 101" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.59C100 78.2 77.6 100.59 50 100.59C22.38 100.59 0 78.2 0 50.59C0 22.97 22.38 0.59 50 0.59C77.6 0.59 100 22.97 100 50.59Z"
                                                    fill="currentColor"/>
                                                <path
                                                    d="M93.97 39.04C96.39 38.4 97.86 35.91 97.01 33.55C95.29 28.82 92.87 24.37 89.81 20.35C85.84 15.11 80.88 10.72 75.21 7.41C69.54 4.1 63.27 1.94 56.77 1.05C51.76 0.36 46.69 0.45 41.73 1.28C39.26 1.69 37.81 4.19 38.45 6.62C39.08 9.04 41.56 10.47 44.05 10.1C47.85 9.54 51.71 9.52 55.54 10.05C60.86 10.77 65.99 12.54 70.63 15.25C75.27 17.96 79.33 21.56 82.58 25.84C84.91 28.91 86.79 32.29 88.18 35.87C89.08 38.21 91.54 39.68 93.97 39.04Z"
                                                    fill="currentFill"/>
                                            </svg>
                                        </div>
                                    ) : (
                                        <Upload className="mx-auto mb-2"/>
                                    )}
                                    <span>{loadingImage ? "Uploading..." : "Upload Images"}</span>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t flex justify-end gap-4">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="px-6 py-2 bg-gray-100 rounded-lg hover:bg-gray-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center gap-2"
                            onClick={createProduct}
                        >
                            {isLoading ? (
                                <span className="animate-pulse">Creating...</span>
                            ) : (
                                <>
                                    <Plus size={18}/>
                                    Create Product
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
